import { createAsyncThunk } from '@reduxjs/toolkit';

import { setLoading } from 'src/components/common/loading/loadingSlice';
import {
	IDeletePatientAssetThunkArgs,
	IPatientAssetUploadResponse,
	IUploadPatientAssetThunkArgs,
} from 'src/features/patient_asset/domain/types';
import { patientAssetApi } from 'src/features/patient_asset/infrastructure/api';
import { handleThunkError } from 'src/utils/handleThunkError';

export const PATIENT_ASSET_LOADING_KEY = 'patient_asset';

export const uploadPatientAssets = createAsyncThunk<
	IPatientAssetUploadResponse[],
	IUploadPatientAssetThunkArgs,
	{ rejectValue: IErrorResponse }
>(
	'patient_asset/uploadPatientAssets',
	async (
		{ request, siteSlug, onSuccess, onError },
		{ dispatch, rejectWithValue },
	) => {
		try {
			dispatch(
				setLoading({ key: PATIENT_ASSET_LOADING_KEY, loading: true }),
			);
			const response = await patientAssetApi.uploadPatientAssets(
				request,
				siteSlug,
			);

			onSuccess?.(response);
			return response;
		} catch (error: unknown) {
			const err = handleThunkError(
				error,
				`Failed to upload ${request[0]?.type}`,
			);
			onError?.(err);
			return rejectWithValue(err);
		} finally {
			dispatch(
				setLoading({ key: PATIENT_ASSET_LOADING_KEY, loading: false }),
			);
		}
	},
);

export const deletePatientAsset = createAsyncThunk<
	void,
	IDeletePatientAssetThunkArgs,
	{ rejectValue: IErrorResponse }
>(
	'patient_asset/deletePatientAsset',
	async (
		{ assetId, type, siteSlug, onSuccess, onError },
		{ dispatch, rejectWithValue },
	) => {
		try {
			dispatch(
				setLoading({
					key: PATIENT_ASSET_LOADING_KEY,
					loading: true,
				}),
			);
			const response = await patientAssetApi.deletePatientAsset(
				assetId,
				siteSlug,
			);

			onSuccess?.();
			return response;
		} catch (error: unknown) {
			const err = handleThunkError(error, `Failed to delete ${type}`);

			onError?.(err);
			return rejectWithValue(err);
		} finally {
			dispatch(
				setLoading({
					key: PATIENT_ASSET_LOADING_KEY,
					loading: false,
				}),
			);
		}
	},
);
